import API_URL from '../config';
import { getAuthHeaders } from '../utils/api';

// eslint-disable-next-line import/prefer-default-export
export const submitFeedback = async ({
  type, message, email, pageUrl, screenshot,
}) => {
  const response = await fetch(`${API_URL}/api/feedback`, {
    method: 'POST',
    headers: {
      ...getAuthHeaders(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      type,
      message,
      email,
      pageUrl,
      screenshot,
    }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to submit feedback');
  }

  return response.json();
};
